export const Gates = {
  PUBLIC_BETA: 'Checkout:BillingPortal:PublicBeta'
};